<template>
  <div>
    <v-card>
      <v-card-title>
        Master Rekening Cabang
        <v-spacer></v-spacer>

        <!-- <v-btn color="purple" dark class="mb-2" @click="doAdd">
            Tambah
          </v-btn> -->

        <v-dialog v-model="dialog" persistent max-width="1000px">
          <v-card>
            <v-card-title>
              <span class="text-h5">Master Rekening</span>
            </v-card-title>
            <v-card-text>
              <v-form
                ref="form"
                v-model="valid"
                lazy-validation
                class="pl-4 pr-4 pt-4"
              >
                <v-row>
                  <v-col cols="6">
                    <v-container>
                      <v-row
                        ><v-col cols="12">
                          <v-combobox
                            label="Bank"
                            clearable
                            dense
                            outlined
                            v-model="currentData.selectedBank"
                            :items="items_bank"
                            item-text="name"
                            :rules="currentData.bankRules"
                          ></v-combobox> </v-col
                      ></v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field
                            label="Nama Rekening Bank"
                            required
                            v-model="currentData.nama_rekening"
                            outlined
                            dense
                            :rules="currentData.namaRekeningRules"
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12">
                          <v-text-field
                            label="No Rekening Bank"
                            required
                            v-model="currentData.no_rekening"
                            outlined
                            dense
                            :rules="currentData.noRekeningRules"
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12">
                          <v-text-field
                            label="Virtual Akun IPaymu"
                            required
                            v-model="currentData.virtual_account"
                            outlined
                            dense
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12">
                          <v-text-field
                            label="No Handphone"
                            required
                            v-model="currentData.telp"
                            outlined
                            dense
                            :rules="currentData.phoneRules"
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12">
                          <v-text-field
                            label="Email"
                            required
                            v-model="currentData.email"
                            outlined
                            dense
                            :rules="currentData.emailRules"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-col>
                  <v-col cols="6">
                    <v-container>
                      <v-row
                        ><v-col cols="12">
                          <v-text-field
                            label="Tanggal Lahir"
                            v-model="currentData.user_tanggal_lahir"
                            type="date"
                            outlined
                            dense
                            :rules="currentData.tanggalLahirRules"
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row
                        ><v-col cols="12">
                          <v-text-field
                            label="Tempat Lahir"
                            v-model="currentData.user_tempat_lahir"
                            outlined
                            dense
                            :rules="currentData.tempatLahirRules"
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row
                        ><v-col cols="12">
                          <v-combobox
                            label="Jenis Kelamin"
                            clearable
                            outlined
                            dense
                            v-model="currentData.selectedJenisKelamin"
                            :items="items_jenis_kelamin"
                            item-text="name"
                            :rules="currentData.jenisKelaminRules"
                          ></v-combobox>
                        </v-col>
                      </v-row>

                      <v-row
                        ><v-col cols="12">
                          <v-text-field
                            label="No KTP"
                            outlined
                            dense
                            v-model="currentData.user_no_ktp"
                            :rules="currentData.noKtpRules"
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row
                        ><v-col cols="12">
                          <v-text-field
                            label="No NPWP"
                            outlined
                            dense
                            v-model="currentData.user_npwp"
                            :rules="currentData.noNpwpRules"
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row
                        ><v-col cols="12">
                          <v-text-field
                            label="Kode POS"
                            outlined
                            dense
                            v-model="currentData.user_kode_pos"
                            :rules="currentData.kodePosRules"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-col>
                </v-row>
                <v-row
                  ><v-col cols="12">
                    <v-text-field
                      label="Alamat Lengkap"
                      outlined
                      dense
                      v-model="currentData.user_alamat"
                      :rules="currentData.addressRules"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6"
                    ><v-combobox
                      label="Propinsi"
                      clearable
                      dense
                      outlined
                      v-model="currentData.selectedPropinsi"
                      :items="items_propinsi"
                      item-text="name"
                      @change="changePropinsi"
                      :rules="currentData.propinsiRules"
                    ></v-combobox
                  ></v-col>
                  <v-col cols="6">
                    <v-combobox
                      label="Kabupaten/Kota"
                      clearable
                      dense
                      outlined
                      v-model="currentData.selectedKabupaten"
                      :items="items_kabupaten"
                      item-text="name"
                      @click="getListKabupatenIPaymu"
                      @change="changeKabupaten"
                      :rules="currentData.kabupatenRules"
                    ></v-combobox>
                  </v-col>
                  <v-col cols="6">
                    <v-combobox
                      label="Kecamatan"
                      clearable
                      dense
                      outlined
                      v-model="currentData.selectedKecamatan"
                      :items="items_kecamatan"
                      item-text="name"
                      @click="getListKecamatanIPaymu"
                      @change="changeKecamatan"
                      :rules="currentData.kecamatanRules"
                    ></v-combobox>
                  </v-col>
                  <v-col cols="6">
                    <v-combobox
                      label="Kelurahan"
                      clearable
                      dense
                      outlined
                      v-model="currentData.selectedKelurahan"
                      :items="items_kelurahan"
                      item-text="name"
                      @click="getListKelurahanIPaymu"
                      :rules="currentData.kelurahanRules"
                    ></v-combobox>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-file-input
                          @change="loadImage"
                          accept="image/png, image/jpeg, image/jpg"
                          v-model="currentData.foto_tabungan"
                          prepend-icon="mdi-image"
                          show-size
                          label="Foto Buku Tabungan"
                          outlined
                          dense
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-responsive
                          v-if="currentData.FotoUrl"
                          :aspect-ratio="16 / 9"
                        >
                          <v-img
                            :key="currentData.fotoKey"
                            :src="currentData.FotoUrl"
                            contain
                          ></v-img>
                        </v-responsive>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col cols="6">
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-file-input
                          @change="loadImageKtp"
                          accept="image/png, image/jpeg, image/jpg"
                          v-model="currentData.user_ktp"
                          prepend-icon="mdi-image"
                          show-size
                          label="Foto KTP"
                          outlined
                          dense
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-responsive
                          v-if="currentData.FotoKtpUrl"
                          :aspect-ratio="16 / 9"
                        >
                          <v-img
                            :key="currentData.fotoKtpKey"
                            :src="currentData.FotoKtpUrl"
                            contain
                          ></v-img>
                        </v-responsive>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col cols="6">
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-file-input
                          @change="loadImageSelfie"
                          accept="image/png, image/jpeg, image/jpg"
                          v-model="currentData.user_selfie"
                          prepend-icon="mdi-image"
                          show-size
                          label="Foto Selfie dengan KTP"
                          outlined
                          dense
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-responsive
                          v-if="currentData.FotoSelfieUrl"
                          :aspect-ratio="16 / 9"
                        >
                          <v-img
                            :key="currentData.fotoSelfieKey"
                            :src="currentData.FotoSelfieUrl"
                            contain
                          ></v-img>
                        </v-responsive>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialog = false">
                Close
              </v-btn>
              <v-btn color="blue darken-1" text @click="doSave"> Save </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="text-h5"
              >Apa anda akan menghapus data ini?</v-card-title
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete"
                >Tidak</v-btn
              >
              <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                >Ya</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-title>
      <v-row class="mx-6 mb-6">
        <v-col cols="12" sm="4" md="4">
          <v-combobox
            label="Cabang Perdatin"
            clearable
            dense
            outlined
            v-model="search.selectedPropinsi"
            :items="items_cabang"
            item-text="name"
            @change="getDataFromApi"
            :disabled="getCabangPengurusId != null"
          ></v-combobox>
        </v-col>
        <v-col cols="12" sm="4" md="4">
          <v-text-field
            v-model="search.nama"
            append-icon="mdi-magnify"
            label="Cari nama"
            single-line
            hide-details
            v-on:keyup.enter="getDataFromApi"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="list_data"
        :options.sync="options"
        :server-items-length="totalData"
        :loading="loading"
        class="elevation-1"
      >
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon medium class="mr-3" @click="editItem(item)">
            mdi-pencil
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import MasterRekeningService from "../services/MasterRekeningService";
import CommonService from "../services/CommonService";
import NakesService from "../services/NakesService";
import store from "../store/index";
import * as moment from "moment";

export default {
  data: () => ({
    valid: true,
    breadcrumbs: [
      {
        text: "Data Cabang Perdatin",
        disabled: true,
        href: "breadcrumbs_dashboard",
      },
    ],
    search: {
      nama: "",
      selectedPropinsi: "",
    },
    headers: [
      {
        text: "No",
        align: "start",
        sortable: false,
        value: "no",
      },
      { text: "Nama", value: "nama", sortable: false },
      { text: "Bank", value: "bank_name", sortable: false },
      { text: "Nama Rekening", value: "nama_rekening", sortable: false },
      { text: "No Rekening", value: "no_rekening", sortable: false },
      {
        text: "Virtual Akun IPaymu",
        value: "virtual_account",
        sortable: false,
      },
      { text: "Actions", value: "actions", sortable: false },
    ],
    isFirst: false,
    totalData: 0,
    list_data: [],
    loading: true,
    options: {
      itemsPerPage: 10,
    },

    editedIndex: -1,
    editedItem: {},
    dialog: false,
    dialogDelete: false,

    currentData: {
      id: null,
      nama: "",
      no_rekening: "",
      nama_rekening: "",
      virtual_account: "",
      selectedBank: "",
      urutan: "",
      telp: "",
      fax: "",
      email: "",
      alamat: "",
      website: "",
      latitude: "",
      longitude: "",
      foto_tabungan: null,
      fileKey: 0,
      FotoUrl: "",
      fotoKey: 0,
      fotoKtpKey: 0,
      fotoSelfieKey: 0,
      user_tanggal_lahir: "",
      user_tempat_lahir: "",
      selectedGender: "",
      user_no_ktp: "",
      selectedPropinsi: "",
      selectedKabupaten: "",
      selectedKecamatan: "",
      selectedKelurahan: "",
      user_kode_pos: "",
      user_alamat: "",
      user_npwp: "",
      user_ktp: null,
      user_selfie: null,
      bankRules: [(v) => !!v || "Bank harus diisi"],
      namaRekeningRules: [(v) => !!v || "Nama Rekening Bank harus diisi"],
      noRekeningRules: [(v) => !!v || "No Rekening Bank harus diisi"],
      phoneRules: [(v) => !!v || "No Handphone harus diisi"],
      emailRules: [(v) => !!v || "Email harus diisi"],
      tanggalLahirRules: [(v) => !!v || "Tanggal Lahir harus diisi"],
      tempatLahirRules: [(v) => !!v || "Tempat Lahir harus diisi"],
      jenisKelaminRules: [(v) => !!v || "Jenis Kelamin harus diisi"],
      noKtpRules: [(v) => !!v || "No KTP harus diisi"],
      noNpwpRules: [(v) => !!v || "No NPWP harus diisi"],
      kodePosRules: [(v) => !!v || "Kode Pos harus diisi"],
      propinsiRules: [(v) => !!v || "Propinsi harus diisi"],
      kabupatenRules: [(v) => !!v || "Kota/Kabupaten harus diisi"],
      kecamatanRules: [(v) => !!v || "Kecamatan harus diisi"],
      kelurahanRules: [(v) => !!v || "Kelurahan harus diisi"],
      addressRules: [
        (v) => !!v || "Alamat harus diisi",
        (v) => (v && v.length <= 200) || "Maksimal alamat 200 karakter",
      ],
    },
    items_cabang: [],
    items_bank: [],
    items_jenis_kelamin: [
      {
        code: "L",
        name: "Laki-Laki",
      },
      {
        code: "P",
        name: "Perempuan",
      },
    ],
    items_propinsi: [],
    items_kabupaten: [],
    items_kecamatan: [],
    items_kelurahan: [],
  }),
  watch: {
    options: {
      handler() {
        if (this.isFirst) {
          this.getDataFromApi();
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.getListPropinsi();
    this.getListPropinsiIPaymu();
    this.getListMasterBank();
    // this.getListJenisKelamin();
    this.getDataFromApi();
  },
  methods: {
    checkFileSize(file) {
      console.log(file.size);

      return true;
    },
    loadImage: function (data) {
      console.log("loadImage:", data);
      if (data) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.$nextTick(() => {
            this.currentData.FotoUrl = e.target.result;
            this.currentData.fotoKey++;
          });
        };
        reader.readAsDataURL(data);
      } else {
        this.currentData.FotoUrl = "";
        this.currentData.foto_tabungan = null;
      }
    },

    loadImageKtp: function (data) {
      console.log("loadImage:", data);
      if (data) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.$nextTick(() => {
            this.currentData.FotoKtpUrl = e.target.result;
            this.currentData.fotoKtpKey++;
          });
        };
        reader.readAsDataURL(data);
      } else {
        this.currentData.FotoKtpUrl = "";
        this.currentData.user_ktp = null;
      }
    },

    loadImageSelfie: function (data) {
      console.log("loadImage:", data);
      if (data) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.$nextTick(() => {
            this.currentData.FotoSelfieUrl = e.target.result;
            this.currentData.fotoSelfieKey++;
          });
        };
        reader.readAsDataURL(data);
      } else {
        this.currentData.FotoSelfieUrl = "";
        this.currentData.user_selfie = null;
      }
    },

    getDataFromApi() {
      const { page, itemsPerPage } = this.options;

      var propinsi = "";

      if (this.search.selectedPropinsi) {
        propinsi = this.search.selectedPropinsi.id;
      }

      this.loading = true;
      MasterRekeningService.masterRekeningList(
        page,
        itemsPerPage,
        this.search.nama,
        propinsi
      )
        .then((res) => {
          this.list_data = res.data.list_data;
          this.totalData = res.data.total;
          this.loading = false;
          this.isFirst = true;
        })
        .catch((err) => {
          this.loading = false;
          this.isFirst = true;
          console.log(err);
        });
    },

    doAdd: async function () {
      this.dialog = true;
      this.currentData.id = null;
      this.currentData.nama = "";
      this.currentData.no_rekening = "";
      this.currentData.nama_rekening = "";
      this.currentData.virtual_account = "";
      this.currentData.urutan = "";
      this.currentData.telp = "";
      this.currentData.fax = "";
      this.currentData.email = "";
      this.currentData.alamat = "";
      this.currentData.website = "";
      this.currentData.foto_url = null;
      this.currentData.FotoUrl = "";

      console.log("do add");
    },

    doSave: async function () {
      console.log(1);
      if (!this.$refs.form.validate()) {
        return;
      }

      console.log(2);

      if (
        !this.editedItem.foto_tabungan_original &&
        !this.currentData.foto_tabungan
      ) {
        CommonService.showErrorToast("Foto Buku Tabungan harus diisi");
        return;
      }

      console.log(3);
      if (!this.editedItem.user_ktp_original && !this.currentData.user_ktp) {
        CommonService.showErrorToast("Foto KTP harus diisi");
        return;
      }

      console.log(4);
      if (
        !this.editedItem.user_selfie_original &&
        !this.currentData.user_selfie
      ) {
        CommonService.showErrorToast("Foto Selfie dengan KTP harus diisi");
        return;
      }

      console.log(5);
      //check ukuran foto buku tabungan
      if (
        this.currentData.foto_tabungan &&
        this.currentData.foto_tabungan.size > 2 * 1024 * 1024
      ) {
        CommonService.showErrorToast("Maksimal ukuran foto buku tabungan 2MB");
        return;
      }

      console.log(6);
      if (
        this.currentData.user_ktp &&
        this.currentData.user_ktp.size > 2 * 1024 * 1024
      ) {
        CommonService.showErrorToast("Maksimal ukuran foto KTP 2MB");
        return;
      }

      console.log(7);
      if (
        this.currentData.user_selfie &&
        this.currentData.user_selfie.size > 2 * 1024 * 1024
      ) {
        CommonService.showErrorToast(
          "Maksimal ukuran foto Selfie dengan KTP 2MB"
        );
        return;
      }

      console.log(8);
      if (this.currentData.id != null) {
        MasterRekeningService.update(this.currentData)
          .then((res) => {
            console.log(res);
            this.dialog = false;
            CommonService.showSuccessToast("Update Master Rekening berhasil");

            this.getDataFromApi();
          })
          .catch((err) => {
            console.log(err);
            CommonService.showErrorToast(
              "Update Master Rekening gagal. Coba lagi"
            );
          });
      } else {
        MasterRekeningService.create(this.currentData)
          .then((res) => {
            console.log(res);
            this.dialog = false;
            CommonService.showSuccessToast("Tambah Master Rekening berhasil");

            this.getDataFromApi();
          })
          .catch((err) => {
            console.log(err);
            CommonService.showErrorToast(
              "Tambah Master Rekening gagal. Coba lagi"
            );
          });
      }
    },

    editItem(item) {
      console.log(item);
      this.editedIndex = this.list_data.indexOf(item);
      this.editedItem = Object.assign({}, item);

      this.dialog = true;
      this.currentData.nama = this.editedItem.nama;
      this.currentData.no_rekening = this.editedItem.no_rekening;
      this.currentData.nama_rekening = this.editedItem.nama_rekening;
      this.currentData.virtual_account = this.editedItem.virtual_account;
      this.currentData.urutan = this.editedItem.urutan;
      this.currentData.telp = this.editedItem.telp;
      this.currentData.fax = this.editedItem.fax;
      this.currentData.email = this.editedItem.email;
      this.currentData.alamat = this.editedItem.alamat;
      this.currentData.website = this.editedItem.website;

      if (this.editedItem.foto_tabungan_original)
        this.currentData.FotoUrl = this.editedItem.foto_tabungan;
      else this.currentData.FotoUrl = null;

      if (this.editedItem.user_ktp_original)
        this.currentData.FotoKtpUrl = this.editedItem.user_ktp;
      else this.currentData.FotoKtpUrl = null;

      if (this.editedItem.user_selfie_original)
        this.currentData.FotoSelfieUrl = this.editedItem.user_selfie;
      else this.currentData.FotoSelfieUrl = null;

      this.currentData.id = this.editedItem.id;
      this.currentData.user_tempat_lahir = this.editedItem.user_tempat_lahir;
      this.currentData.user_no_ktp = this.editedItem.user_no_ktp;
      this.currentData.user_kode_pos = this.editedItem.user_kode_pos;
      this.currentData.user_alamat = this.editedItem.user_alamat;
      this.currentData.user_npwp = this.editedItem.user_npwp;
      this.currentData.fotoKey++;

      if (this.editedItem.user_tanggal_lahir) {
        this.currentData.user_tanggal_lahir = moment(
          this.editedItem.user_tanggal_lahir
        ).format("YYYY-MM-DD");
      }

      this.currentData.selectedBank = null;

      if (this.editedItem.bank_code) {
        this.$nextTick(() => {
          this.currentData.selectedBank = {
            code: this.editedItem.bank_code,
            name: this.editedItem.bank_name,
          };
        });
      }

      this.currentData.selectedJenisKelamin = null;

      this.items_jenis_kelamin.forEach((entry) => {
        if (entry.code == this.editedItem.user_gender) {
          this.currentData.selectedJenisKelamin = entry;
        }
      });

      if (this.editedItem.user_propinsi) {
        this.currentData.selectedPropinsi = {
          code: this.editedItem.user_propinsi,
          name: this.editedItem.user_propinsi_name,
        };
      }

      if (this.editedItem.user_kabupaten) {
        this.currentData.selectedKabupaten = {
          code: this.editedItem.user_kabupaten,
          name: this.editedItem.user_kabupaten_name,
        };
      }

      if (this.editedItem.user_kecamatan) {
        this.currentData.selectedKecamatan = {
          code: this.editedItem.user_kecamatan,
          name: this.editedItem.user_kecamatan_name,
        };
      }

      if (this.editedItem.user_kelurahan) {
        this.currentData.selectedKelurahan = {
          code: this.editedItem.user_kelurahan,
          name: this.editedItem.user_kelurahan_name,
        };
      }

      console.log("do edit");
    },

    deleteItem(item) {
      console.log(item);
      this.editedIndex = this.list_data.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.closeDelete();

      MasterRekeningService.delete(this.editedItem.id)
        .then((res) => {
          console.log(res);
          CommonService.showSuccessToast("Hapus Master Rekening berhasil");

          this.getDataFromApi();
        })
        .catch((err) => {
          console.log(err);

          CommonService.showErrorToast(
            "Hapus Master Rekening gagal. Coba lagi"
          );
        });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    changeFile: function (file) {
      console.log("changeMateriFile:", file);
      console.log(file.name);
      this.currentData.fileKey++;
    },

    async getListPropinsi() {
      NakesService.propinsiList()
        .then((res) => {
          this.items_cabang = res.data.list_data;

          console.log(this.getCabangPengurusId);
          if (this.getCabangPengurusId) {
            this.items_cabang.forEach((entry) => {
              if (entry.id == this.getCabangPengurusId) {
                this.search.selectedPropinsi = entry;
                this.getDataFromApi();
              }
            });
          } else {
            this.getDataFromApi();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getListMasterBank() {
      NakesService.masterBankList()
        .then((res) => {
          if (res.data.resp.Status == 200) {
            this.items_bank = res.data.resp.Data.bank;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getListJenisKelamin() {
      NakesService.jenisKelaminList()
        .then((res) => {
          this.items_jenis_kelamin = res.data.list_data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async getListPropinsiIPaymu() {
      NakesService.propinsiListIpaymu()
        .then((res) => {
          if (res.data.resp.Status == 200) {
            this.items_propinsi = res.data.resp.Data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async getListKabupatenIPaymu() {
      console.log(this.currentData.selectedPropinsi);
      NakesService.kabupatenListIpaymu(this.currentData.selectedPropinsi.code)
        .then((res) => {
          if (res.data.resp.Status == 200) {
            this.items_kabupaten = res.data.resp.Data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async getListKecamatanIPaymu() {
      NakesService.kecamatanListIpaymu(this.currentData.selectedKabupaten.code)
        .then((res) => {
          if (res.data.resp.Status == 200) {
            this.items_kecamatan = res.data.resp.Data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async getListKelurahanIPaymu() {
      NakesService.kelurahanListIpaymu(this.currentData.selectedKecamatan.code)
        .then((res) => {
          if (res.data.resp.Status == 200) {
            this.items_kelurahan = res.data.resp.Data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async changePropinsi() {
      this.currentData.selectedKabupaten = null;
      this.currentData.selectedKecamatan = null;
      this.currentData.selectedKelurahan = null;
    },

    async changeKabupaten() {
      this.currentData.selectedKecamatan = null;
      this.currentData.selectedKelurahan = null;
    },
    async changeKecamatan() {
      this.currentData.selectedKelurahan = null;
    },
  },

  computed: {
    getRoleId() {
      return store.getters.getUser.role_id;
    },
    getCabangPengurusId() {
      return store.getters.getUser.cabang_pengurus_id;
    },
    getIsVerified() {
      return this.isVerified;
    },
    getUser() {
      return store.getters.getUser;
    },
  },
};
</script>
